// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"1463":"396868d5bbf83141ed3b","3919":"aa4775029fb3e87afa54"}[chunkId] + ".js";
};